import { render, staticRenderFns } from "./ManageData.vue?vue&type=template&id=6c1b5c4c&scoped=true&"
import script from "./ManageData.vue?vue&type=script&lang=js&"
export * from "./ManageData.vue?vue&type=script&lang=js&"
import style0 from "./ManageData.vue?vue&type=style&index=0&id=6c1b5c4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1b5c4c",
  null
  
)

export default component.exports